/* ═══════════════════════════════════════════════════════════════════════════
   RITUEL-K — Premium Polish JS v1
   - Reveal au scroll sur sections principales
   - Classe is-scrolled sur .section-header (renforce l'effet Dawn natif)
   - Léger et sans dépendance
═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── 1. Scroll header effect ────────────────────────────────────────────────
  var sectionHeader = document.querySelector('.section-header');
  function onScroll() {
    if (!sectionHeader) return;
    if (window.scrollY > 8) sectionHeader.classList.add('is-scrolled');
    else sectionHeader.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── 2. Reveal au scroll via IntersectionObserver ──────────────────────────
  function tagForReveal() {
    if (prefersReducedMotion) return;

    var selectors = [
      '.featured-collection .grid__item',
      '.collection .grid__item',
      'ul#product-grid > .grid__item',
      '.multicolumn-list .multicolumn-list__item',
      '.image-with-text',
      '.banner',
      '.rich-text',
      '.section-template--featured-product',
    ];
    var seen = new WeakSet();
    selectors.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      nodes.forEach(function (n) {
        if (seen.has(n)) return;
        seen.add(n);
        // Évite de retagger header / footer / sticky structures
        if (
          n.closest('.section-header') ||
          n.id === 'shopify-section-footer-group' ||
          n.classList.contains('shopify-section-group-footer-group')
        ) {
          return;
        }
        n.setAttribute('data-rk-reveal', '');
      });
    });
  }

  function setupObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback : tout afficher
      document.querySelectorAll('[data-rk-reveal]').forEach(function (el) {
        el.classList.add('rk-revealed');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rk-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('[data-rk-reveal]').forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    tagForReveal();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
